/**
 * Blog Preview Page
 *
 * Public page for previewing potential blogs before publication
 * Accessible to anyone with the preview link (no authentication required)
 */

import BlogPreviewClient from '@/components/BlogPreviewClient';

export default function BlogPreviewPage() {
  return <BlogPreviewClient />;
}
